export default "__VITE_ASSET__$sUeaP4N__"